import React, { useState, useEffect } from 'react';
import ReactDOM from 'react-dom';
import WithCart from "../Cart/WithCart";
import MakeForm from "../Form/MakeForm";

import FormErrorBoundary from "./FormErrorBoundary";

function MakeCartPageWithErrorBoundary(props){

  return (<FormErrorBoundary>
    <WithCart {...props}>
      <MakeForm {...props} />
    </WithCart>

  </FormErrorBoundary>)

  return (<CartPageErrorBoundary>
  </CartPageErrorBoundary>)
}

export default MakeCartPageWithErrorBoundary;
